import { Suspense, lazy } from "react";
import "./App.css";
import {
  Navigate,
  Route,
  Routes,
  BrowserRouter as Router,
} from "react-router-dom";

const Login = lazy(() => import("./Rhenoflex-page/AdminLogin") as any);
const DashBoard = lazy(() => import("./Rhenoflex-page/Dashboard") as any);

function App() {
  return (
    <>
      <Router>
        <Suspense>
          <Routes>
            <Route path="/" element={sessionStorage.getItem('crend') !== null ? <Navigate to={`/dashboard`} /> :  <Navigate to={`/login`} />} />
            <Route path="/login" element={<Login/>} />
            <Route path="/dashboard" element={<DashBoard />} />
          </Routes>
        </Suspense>
      </Router>
    </>
  );
}

export default App;